export default __webpack_public_path__ + "static/media/uploader-caresens-problem-1.26167101.png";